import React from "react";
import { Button, CircularProgress } from "@mui/material";

function ButtonInput({
  title,
  type = "contained",
  side = "start",
  disabled = false,
  onClick = () => {},
  loading
}) {
  return (
    <div style={{ display: "flex", justifyContent: side }}>
      
      <Button
        variant={type}
        loading={loading}
        sx={{
          fontSize: "14px",
          margin: "4px",
          borderRadius: "0px",
          width: "150px",
          flexWrap:'',
          backgroundColor: type === 'contained' && "rgb(223, 32, 32)",
        }}
        onClick={onClick}
        disabled={disabled}
      >
        {/* <CircularProgress size={16} sx={{margin:'0 4px 0 0 '}}/> */}
        {title}
      </Button>
    </div>
  );
}

export default ButtonInput;
